/* @flow */

import React, { Component } from 'react';
import { Grid, Form, Image, Segment } from 'semantic-ui-react';
import ProgressiveImage from 'shared/components/ProgressiveImage';
import loader from 'static/images/image-loader.svg';
import { getVideoPlaceholder } from 'utils/resources';
import {
  THUMBNAIL_THROTTLE_MILLIS,
  tryExtractId,
  fetchThumbnail,
} from 'utils/youtube';
import throttle from 'lodash/throttle';

type Props = {
  content: CatalogPageContent,
  onSerialize?: (content: CatalogPageContent) => void,
};

type State = {
  value?: string,
  currentThumbnail?: string,
  error: boolean,
};

// TODO: Refactor to abstract it with Edito Youtube block (edito/plugins/youtube/Edit)
// TODO: We should develop a HOC for this usage

const contentToUrl = content => {
  return content.youtubeId
    ? `https://www.youtube.com/watch?v=${content.youtubeId}`
    : '';
};

class Edit extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      error: false,
      thumbnailThrottle: throttle(
        this.getThumbnail,
        THUMBNAIL_THROTTLE_MILLIS,
        { trailing: true }
      ),
    };
  }

  getThumbnail = id => {
    if (id) {
      fetchThumbnail(id).then(
        response => {
          const { video } = response;
          if (video) {
            this.setState({
              currentThumbnail: video.thumbnail,
            });

            this.props.onSerialize({
              ...this.props.content,
              thumbnail: video.thumbnail,
            });
          }
        },
        _ => {
          this.setState({
            error: true,
          });
        }
      );
    }
  };

  onUrlChanged = (event: SyntheticEvent) => {
    const { content, onSerialize } = this.props;

    if (event.target instanceof HTMLInputElement) {
      const { value } = event.target;

      const youtubeId = tryExtractId(value);
      const isValid = youtubeId !== null;

      this.setState({
        value,
        error: !isValid,
      });

      if (isValid) {
        this.state.thumbnailThrottle(youtubeId);

        onSerialize({
          ...content,
          youtubeId,
        });
      }
    }
  };
  render() {
    const { content } = this.props;
    const { value, error } = this.state;

    const url = value || contentToUrl(content);
    const thumbnail =
      this.state.currentThumbnail || content.thumbnail || getVideoPlaceholder;

    return (
      <Segment>
        <Grid>
          <Grid.Column width={4}>
            <ProgressiveImage
              src={thumbnail}
              crossOrigin={null}
              placeholder={loader}
            >
              {src => <Image src={src} />}
            </ProgressiveImage>
          </Grid.Column>
          <Grid.Column width={12} verticalAlign="middle">
            <Form>
              <Form.Input
                value={url}
                error={error}
                label="Lien vidéo Youtube"
                placeholder="https://www.youtube.com/watch?v="
                onChange={this.onUrlChanged}
              />
            </Form>
          </Grid.Column>
        </Grid>
      </Segment>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/youtube/Edit.js